
@if (!noMenus) {
  <div id="main" class="main">
    @if (loginDisplay && menus) {
      <app-sidebar  [menus]="menus" ></app-sidebar>
    }
    @if (!loginDisplay) {
      <div class="container">
        <div class="forms-container">
          <div class="signin-signup">
            <form action="#" class="sign-in-form">
              <img width="200px" height="81px" class="image-login" src="assets/logo.webp" alt="logo">
              <input (click)="onSubmit()" type="button" value="Login" class="btn solid" />
              <p class="social-text">Síguenos en nuestras redes sociales</p>
              <div class="social-media">
                <a href="https://www.instagram.com/" class="social-icon">
                  <i style="font-size: 15px;" class='bx bxl-instagram-alt' ></i>
                </a>
                <a href="https://ec.linkedin.com/" class="social-icon">
                  <i style="font-size: 15px;" class='bx bxl-linkedin'></i>
                </a>
                <a href="https://www.facebook.com/" class="social-icon">
                  <i style="font-size: 15px;" class='bx bxl-facebook'></i>
                </a>
                <a href="https://www.youtube.com/" class="social-icon">
                  <i style="font-size: 15px;" class='bx bxl-youtube'></i>
                </a>
              </div>
            </form>
          </div>
        </div>
        <div class="panels-container">
          <div class="panel left-panel">
            <div class="content">
              <h3>¿ No tienes usuario ?</h3>
              <p>
                Por favor contáctate con el administrador del sistema inmediatamente!!
              </p>
              <a href="mailto:javierqwer1@medianet.org.ec">
                <button class="btn transparent" id="sign-up-btn">
                  Contactar
                </button>
              </a>
            </div>
            <img width="468px" height="278px" src="assets/login/log.svg" class="image" alt="" />
          </div>
        </div>
      </div>
    }
  </div>
}

@if (noMenus) {
  <app-error-page code="Opps..." title="No puedes acceder" subtitle="No tiene los permisos necesarios para acceder a esta página." />
}

@if (noMenus) {
  <div  class="grid">
    <div class="col-12" style="display: flex; justify-content: center; align-items: center;">
      @if (noMenus) {
        <p-button (onClick)="CerrarSesion()" [style]="{'backgroundColor': 'red', 'borderColor':'red'}" label="Cerrar" class="p-button-info p-button-rounded p-button-text"></p-button>
      }
    </div>
  </div>
}


